import React from 'react';
import { DangerouslySetInnerHTML } from '../SectionComponents/helpers/DangerouslySetInnerHTML';
import { tryDecodeURI } from '../../helpers/string';
import { replaceWithEditorSafeImageUrls } from '@helpers/editorHelpers';
import { ckEditorHTMLStyles as classes } from './styleObjects/ckEditorHTMLStyles';

interface RenderedCKEditorArticleProps {
    content: string;
    mediaUrlPrefix: string;
}

export default function RenderedCKEditorArticle({
    content,
    mediaUrlPrefix,
}: RenderedCKEditorArticleProps): JSX.Element {
    return (
        <DangerouslySetInnerHTML
            parseLinks
            css={[classes.container, classes.articleStyles]}
            html={tryDecodeURI(replaceWithEditorSafeImageUrls(content, mediaUrlPrefix))}
        />
    );
}
